import React from 'react';

import { Link } from "react-router-dom";
import { UserIcon } from '../../icons/UserIcon';
import { Menu, Dropdown } from 'antd';
import { Flex, UserBox } from '../../components/Flex';

const UserMenu = ({ name, lastname }) => {

    const menu = (
        <Menu className="user-menu">
            <Menu.Item key="0" disabled>
                Reset password
            </Menu.Item>
            <Menu.Item key="1" disabled>
                About
            </Menu.Item>
            <Menu.Item key="2">
                <Link to='/logout'>
                    Log out
                </Link>
            </Menu.Item>
        </Menu>
    );

    return(
        <Dropdown overlay={menu} className="user-menu" trigger="click">
            <Flex style={{ cursor: "pointer" }} gap={{ right: 8 }}>
                <UserIcon />
                <UserBox>
                    <span>{name}</span>
                    <span>{lastname}</span>
                </UserBox>
            </Flex>
        </Dropdown>
    );
};


export { UserMenu };
